import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getInnerLinkTheme = function getInnerLinkTheme(theme) {
  return ThemeFactory.create({
    linkLineBorderBottomStyle: theme.btnLinkLineBorderBottomStyle,
    linkLineHoverBorderBottomStyle: theme.btnLinkHoverLineBorderBottomStyle,
    linkLineBorderBottomOpacity: theme.btnLinkLineBorderBottomOpacity,
    linkLineBorderBottomColor: theme.btnLinkLineBorderBottomColor,
    linkLineBorderBottomWidth: theme.btnLinkLineBorderBottomWidth,
    linkDisabledColor: theme.btnLinkDisabledColor,
    linkColor: theme.btnLinkColor,
    linkHoverColor: theme.btnLinkHoverColor,
    linkActiveColor: theme.btnLinkActiveColor,
    linkHoverTextDecoration: theme.btnLinkHoverTextDecoration,
    linkIconMarginRight: theme.btnLinkIconMarginRight,
    linkBorderRadius: theme.btnLinkBorderRadius
  }, theme);
};